import type { FeatureRequestStatus } from '../../types';
import type { StatusChipColor } from '../../theme';

export interface FeatureRequestStatusMeta {
  label: string;
  color: StatusChipColor;
}

/** Nhãn + màu tiếng Việt cho từng trạng thái yêu cầu chức năng. */
export const FEATURE_REQUEST_STATUS_META: Record<FeatureRequestStatus, FeatureRequestStatusMeta> = {
  NEW: { label: 'Mới', color: 'info' },
  REVIEWING: { label: 'Đang xem xét', color: 'warning' },
  CONVERTED: { label: 'Đã chuyển', color: 'success' },
  REJECTED: { label: 'Từ chối', color: 'default' },
};

export const FEATURE_REQUEST_STATUS_OPTIONS: FeatureRequestStatus[] = [
  'NEW',
  'REVIEWING',
  'CONVERTED',
  'REJECTED',
];
